// Team badges open the in-app team page (/teams/<slug>). Slugs come from the team index the
// seo-pages job publishes next to the public team pages: {team_id: slug}.
let index;

export function teamSlug(teamId) {
  if (!index) {
    index = fetch("/football/teams/index.json")
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return index.then((map) => map[String(teamId)]);
}

export default {
  methods: {
    async openTeam(team) {
      const slug = team && team.team_id && (await teamSlug(team.team_id));
      if (slug && this.$route.path !== `/teams/${slug}`) {
        this.$router.push(`/teams/${slug}`);
      }
    },
  },
};
